import React from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { INSURANCE_ACCEPTANCE } from '@root/src/types';
import config from '@root/src/config';
import { textP, textPLink } from '@features/ui/styles/textStyles';
import InputLine from '@features/ui-input/formik/InputLine';
import InputCheckbox from '@features/ui-input/components/InputCheckbox';

export const INSURANCE_DOCUMENTS = [
  {
    key: 'preServiceDocumentInsuranceDocument_CGASummary.message',
    url: (lang) => config.documentsPath.cgaSummary[lang],
  }, {
    key: 'preServiceDocumentInsuranceDocument_CGA.message',
    url: (lang) => config.documentsPath.cga[lang],
  },
];

const PreServiceInsurance = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Container>
      {t('preServicesInputFactory_defaultInsuranceDescription.message')}
      {INSURANCE_DOCUMENTS.map(document => (
        <a key={document.key} href={document.url(router.locale)} target="_blank" rel="noreferrer">{t(document.key)}</a>
      ))}
      <InputWrapper>
        <InputLine
          name={INSURANCE_ACCEPTANCE}
          as={InputCheckbox}
          checkboxLabel={t('preServicesInputFactory_insuranceAcceptance.message')}
        />
      </InputWrapper>
    </Container>
  );
};

export default PreServiceInsurance;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  & a {
    ${textPLink};
    color: var(--color-black);
    :active,
    :hover {
      color: var(--color-orange-hover);
    }
  }
  ${textP};
`;

const InputWrapper = styled.div`
  margin-top: 10px;
`;
